export function normalizeLinkSymbol(value = "") {
  return String(value || "")
    .trim()
    .toLowerCase();
}

export function isDuplicateLinkSymbol(nextValue, otherValue) {
  const next = normalizeLinkSymbol(nextValue);
  const other = normalizeLinkSymbol(otherValue);
  return Boolean(next && other && next === other);
}

export function buildLinkSymbolOptions(broker = {}, excludedSymbol = "") {
  const rawSymbols = Array.isArray(broker.symbols) ? broker.symbols : [];
  const values = rawSymbols.map((symbol) => String(symbol || "").trim()).filter(Boolean);
  const requestedSymbol = String(broker.requestedSymbol || "").trim();
  const normalizedSelected = normalizeLinkSymbol(requestedSymbol);
  const normalizedExcluded = normalizeLinkSymbol(excludedSymbol);

  if (
    requestedSymbol &&
    !values.some((symbol) => normalizeLinkSymbol(symbol) === normalizedSelected)
  ) {
    values.unshift(requestedSymbol);
  }

  return values
    .filter((symbol) => {
      const normalizedSymbol = normalizeLinkSymbol(symbol);
      if (!normalizedExcluded) return true;
      if (normalizedSymbol === normalizedSelected) return true;
      return normalizedSymbol !== normalizedExcluded;
    })
    .map((symbol) => ({ value: symbol, label: symbol }));
}

export function enforceDistinctSameBrokerSymbols(brokers = []) {
  const next = Array.isArray(brokers) ? brokers.map((broker) => ({ ...broker })) : [];
  if (next.length < 2) return next;

  if (isDuplicateLinkSymbol(next[0]?.requestedSymbol, next[1]?.requestedSymbol)) {
    next[1] = { ...next[1], requestedSymbol: "" };
  }

  return next;
}
